module.exports = "/_next/static/images/OrchestrateJourneys@2x-2c9ca120bf28849604e5c9b5ee6a0543.webp";